import { CardMedia, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React from "react";

const useStyle = makeStyles({
  imageCircle: {
    height: "19em",
    width: "19em",
  },
  image: {
    height: 100,
    backgroundColor: "#fff",
    objectFit: "contain",
    paddingBlock: 40,
  },
  imageSmall: {
    height: 57,
    paddingBlock: 0,
    backgroundColor: "#fff",
    objectFit: "contain",
  },
  imageSmallCircle: {
    height: "13em",
    width: "13em",
  },
  cover: {
    height: 180,
    paddingBlock: 0,
    objectFit: "cover",
  },
});

type CardMediaImageProps = {
  defaultImage: any;
  src?: any;
  alt?: string;
  circle?: boolean;
  small?: boolean;
  onClick?: () => void;
};

const CardMediaImage = ({
  src,
  defaultImage,
  circle,
  alt,
  small,
  onClick,
}: CardMediaImageProps) => {
  const classes = useStyle();
  return (
    <CardMedia
      className={clsx(
        {},
        {
          [classes.imageCircle]: circle,
          [classes.image]: !circle,
          [classes.imageSmall]: small && !circle,
          [classes.imageSmallCircle]: small && circle,
          [classes.cover]: src && !circle,
        }
      )}
      src={src && src !== "" ? src : defaultImage}
      component="img"
      title={alt || "image"}
      alt={alt || "image"}
      onClick={onClick}
    ></CardMedia>
  );
};

export default CardMediaImage;
